import { createElement, Fragment } from 'react';

var GTMScriptHead = function GTMScriptHead(_ref) {
  var gtm_id = _ref.gtm_id;
  if (!gtm_id) return null;
  return (
    // eslint-disable-next-line @next/next/next-script-for-ga
    createElement("script", {
      type: "text/javascript",
      dangerouslySetInnerHTML: {
        __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','" + gtm_id + "');"
      }
    })
  );
};
var GTMScriptBody = function GTMScriptBody(_ref2) {
  var gtm_id = _ref2.gtm_id;
  if (!gtm_id) return null;
  return createElement("noscript", null, createElement("iframe", {
    src: "https://www.googletagmanager.com/ns.html?id=" + gtm_id,
    height: "0",
    width: "0",
    style: {
      display: "none",
      visibility: "hidden"
    }
  }));
};
var RudderStackScript = function RudderStackScript() {
  var host = "https://sdhp.vercel.app";
  var rsMinJs = host + "/rs.min.js";
  var dataPlane = host + "/rs-dataplane";
  var configUrl = host + "/rs-sourceConfig";
  return createElement("script", {
    type: "text/javascript",
    dangerouslySetInnerHTML: {
      __html: "!function(){var e=window.rudderanalytics=window.rudderanalytics||[];e.methods=[\"load\",\"page\",\"track\",\"identify\",\"alias\",\"group\",\"ready\",\"reset\",\"getAnonymousId\",\"setAnonymousId\",\"getUserId\",\"getUserTraits\",\"getGroupId\",\"getGroupTraits\"],e.factory=function(t){return function(){var r=Array.prototype.slice.call(arguments);return r.unshift(t),e.push(r),e}};for(var t=0;t<e.methods.length;t++){var r=e.methods[t];e[r]=e.factory(r)}e.loadJS=function(e,t){var r=document.createElement(\"script\");r.type=\"text/javascript\",r.async=!0,r.src=\"" + rsMinJs + "\";var a=document.getElementsByTagName(\"script\")[0];a.parentNode.insertBefore(r,a)},e.loadJS(),\n          e.load(\"2E0kslmrvgrH84NmPoKKsFKwhP5\",\"" + dataPlane + "\", {configUrl: \"" + configUrl + "\"}),\n          e.page()}();"
    }
  });
};
var DefaultScripts = function DefaultScripts() {
  return createElement(Fragment, null, createElement(RudderStackScript, null));
};

export { DefaultScripts, GTMScriptBody, GTMScriptHead, RudderStackScript };
//# sourceMappingURL=app-head.esm.js.map
